import * as z from "zod";

export enum TaxProposalType {
  SAVE_TAXES = "save_taxes",
  DONATE_CHARITY = "donate_charity",
}

export const taxOptimizeSchema = z.object({
  taxProposalType: z.enum([
    TaxProposalType.SAVE_TAXES,
    TaxProposalType.DONATE_CHARITY,
  ]),
  teError: z
    .number()
    .nullable()
    .optional()
    .refine((val) => val && val > 0, {
      message:
        "Please enter a value for the optimizer to find a solution. Default value is 5%",
    })
    .refine((val) => val && val < 100, {
      message: "Please enter a value more than 0% and less than 100%",
    }),
  tickerLimit: z.number().nullable().optional(),
  donationLimit: z.string().nullable().optional(),
  targetTaxSavings: z.string().nullable().optional(),
  restrictedSecurities: z.array(z.string()).optional(),
});

export type TaxOptimizeFormConfig = z.infer<typeof taxOptimizeSchema>;
